(() => {

  // スクロール告知バーの初期化
  const initSlideNews = () => {
    const slideNewsItems = document.querySelectorAll('.sopoa-slide-news__item');
    
    slideNewsItems.forEach((item) => {
      const wrapper = item.closest('.sopoa-slide-news__wrapper');
      
      if (wrapper) {
        const rows = wrapper.querySelectorAll('.sopoa-slide-news__row');
        
        item.addEventListener('mouseenter', () => {
          rows.forEach((row) => {
            row.style.animationPlayState = 'paused';
          });
        });
        
        item.addEventListener('mouseleave', () => {
          rows.forEach((row) => {
            row.style.animationPlayState = 'running';
          });
        });
      }
    });
  };

  // 初期化処理
  const init = () => {
    // 各初期化関数の呼び出し
    initSlideNews();
    accordion();
    initSmoothScroll();
  };

  // リサイズ
  const handleResize = () => {
    // 各初期化関数の呼び出し
  };

  // スクロール
  let lastScrollTime = 0;
  const handleScroll = () => {
    const now = Date.now();
    if (now - lastScrollTime >= 100) {
    }
  };

  // アコーディオン開閉
  const accordion = () => {

    const moreBtn = Array.from(document.querySelectorAll('.js-accordion-btn'));

    moreBtn.forEach((item) => {
      item.addEventListener('click', function() {
        this.classList.toggle('is-on');
        const target = this.nextElementSibling;
        
        if (target.style.maxHeight) {
          target.style.maxHeight = null;
        } else {
          target.style.maxHeight = target.scrollHeight + 'px';
        }
      });
    });
  }

  // スクロール位置の調整
  const adjustScrollPosition = (targetElement, behavior = 'smooth') => {
    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.pageYOffset;
    const gap = document.getElementById('header')?.clientHeight || 0 + 80;
    const target = rect + offset - gap;
  
    window.scrollTo({ top: target, behavior });
  };

  // スムーススクロール
  const initSmoothScroll = () => {
    document.querySelectorAll('a[href^="#"]').forEach(trigger => {
      trigger.addEventListener('click', e => {
        e.preventDefault();
        const targetId = trigger.getAttribute('href').replace('#', '');
        const targetElement = document.getElementById(targetId);
        if (targetElement) adjustScrollPosition(targetElement, 'smooth');
      });
    });
  };

  // イベントリスナーの登録
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', handleResize);
  document.addEventListener('scroll', handleScroll);
  
})();